// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1Fd7B","file":"styles_file__uIfeR"};